import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cargando',
  templateUrl: './cargando.component.html',
  styleUrls: ['./cargando.component.scss'],
})
export class CargandoComponent implements OnInit {
  @Input() loading;
  @Input() mensaje;
  constructor() { }

  ngOnInit() {
    
  }

}
